import script from "./BenchmarkSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./BenchmarkSelect.vue?vue&type=script&setup=true&lang=js"

import "./BenchmarkSelect.vue?vue&type=style&index=0&id=822f9d90&lang=css"

const __exports__ = script;

export default __exports__